// 登录请求
import { getRequest,postRequest } from '../tools/ajax.js'

// // 获取图形验证码，无参
// const getCode = params => getRequest('/lt/api/login/code', params, 'blob');

// 登录
const loginApi = params => postRequest('/api/pc/User/Login', params);

const loginByCode = params => postRequest('/api/pc/User/LoginByCode', params);

const GetRoles = params => getRequest('/api/pc/User/GetRoles', params);
//修改密码
const changePassword = params => postRequest('api/pc/Member/ChangePassword', params);

//修改密码
const firstLoginChangePassword = params => postRequest('api/pc/Member/FirstLoginChangePassword', params);


// // 获取用户信息
// const getUserMessageApi = params => getRequest('/lt/api/login/user/info', params);

// // 获取用户列表
// const getUserList = params => getRequest('/lt/api/pajx/user/lookup', params);




export {
  loginApi,
  GetRoles,
  changePassword,
  loginByCode,
  firstLoginChangePassword
  // getCode,
  // getUserMessageApi,
  // getUserList
  // // getinfo
} 